import { Stack, StackProps } from '@mui/material'
import React, { FC } from 'react'
interface Props extends StackProps {}

export const CustomFooterUI: FC<Props> = ({ children, ...props }) => {
  return (
    <Stack
      direction={'row'}
      p={1}
      spacing={1}
      alignItems="center"
      sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}
      {...props}>
      {children}
    </Stack>
  )
}
